import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/order-form/icon_estimation.svg'
import _imports_1 from '@/assets/images/home/kakaku_popup.png'
import _imports_2 from '@/assets/images/home/mobistar_popup_02.png'
import _imports_3 from '@/assets/images/common/arrow_right.svg'


const _withScopeId = n => (_pushScopeId("data-v-3b10fb81"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "formTtl" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fontEn" }, "STEP 1"),
  /*#__PURE__*/_createTextVNode("お見積もり")
], -1))
const _hoisted_2 = { class: "common-section" }
const _hoisted_3 = { class: "condition-input" }
const _hoisted_4 = {
  key: 0,
  class: "products-select"
}
const _hoisted_5 = { class: "button-wrapper" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "submit-button" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon",
    src: _imports_0
  }),
  /*#__PURE__*/_createTextVNode(" 上記内容でお見積り ")
], -1))
const _hoisted_7 = {
  key: 0,
  class: "popup-window"
}
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<input type=\"checkbox\" id=\"popup-switch\" data-v-3b10fb81><div class=\"popup-background\" data-v-3b10fb81></div><div class=\"popup-box\" data-v-3b10fb81><div class=\"popup-content\" data-v-3b10fb81><a href=\"#\" target=\"_self\" data-v-3b10fb81></a><label for=\"popup-switch\" class=\"popup-end\" data-v-3b10fb81></label><label for=\"popup-switch\" class=\"popup-close\" data-v-3b10fb81><img src=\"" + _imports_1 + "\" alt=\"価格.com専用割引特典\" width=\"640px\" style=\"display:block;margin-left:auto;margin-right:auto;\" data-v-3b10fb81></label></div></div>", 3)
const _hoisted_11 = [
  _hoisted_8
]
const _hoisted_12 = {
  key: 1,
  class: "popup-window"
}
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<input type=\"checkbox\" id=\"popup-switch\" data-v-3b10fb81><div class=\"popup-background\" data-v-3b10fb81></div><div class=\"popup-box\" data-v-3b10fb81><div class=\"popup-content\" data-v-3b10fb81><a href=\"#\" target=\"_self\" data-v-3b10fb81></a><label for=\"popup-switch\" class=\"popup-end-mobi\" data-v-3b10fb81></label><label for=\"popup-switch\" class=\"popup-close\" data-v-3b10fb81><img src=\"" + _imports_2 + "\" alt=\"海外携帯レンタル比較ナビ専用割引特典\" width=\"640px\" style=\"display:block;margin-left:auto;margin-right:auto;\" data-v-3b10fb81></label></div></div>", 3)
const _hoisted_16 = [
  _hoisted_13
]
const _hoisted_17 = {
  key: 2,
  class: "estimation-order"
}
const _hoisted_18 = {
  key: 0,
  class: "login-block"
}
const _hoisted_19 = { class: "forward" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "初めてご利用のお客様", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "お申し込み完了と同時にマイページに登録いたします。", -1))
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "forward with-login" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "ご登録済みのお客様", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "マイページにログインをお願いいたします。", -1))
const _hoisted_26 = { class: "input-login-info" }
const _hoisted_27 = { class: "mail" }
const _hoisted_28 = { class: "password" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = { class: "forgot-password" }
const _hoisted_31 = {
  key: 1,
  class: "forward-to-customer-info"
}
const _hoisted_32 = ["disabled"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "arrow-right",
  src: _imports_3
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TravelTerm = _resolveComponent("TravelTerm")!
  const _component_area_select = _resolveComponent("area-select")!
  const _component_Form = _resolveComponent("Form")!
  const _component_wi_fi_product_select = _resolveComponent("wi-fi-product-select")!
  const _component_receiving_method = _resolveComponent("receiving-method")!
  const _component_returning_method = _resolveComponent("returning-method")!
  const _component_optional_insurance = _resolveComponent("optional-insurance")!
  const _component_optional_products = _resolveComponent("optional-products")!
  const _component_coupon_codes = _resolveComponent("coupon-codes")!
  const _component_payment_method = _resolveComponent("payment-method")!
  const _component_estimation_result = _resolveComponent("estimation-result")!
  const _component_common_input = _resolveComponent("common-input")!
  const _component_input_field = _resolveComponent("input-field")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.onSearchProducts,
        onInvalidSubmit: _ctx.onInvalidSubmit
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_TravelTerm, {
              "departure-date": _ctx.formData.order_from_date,
              "onUpdate:departure-date": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.order_from_date) = $event)),
              "arrival-date": _ctx.formData.order_to_date,
              "onUpdate:arrival-date": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.order_to_date) = $event))
            }, null, 8, ["departure-date", "arrival-date"]),
            _createVNode(_component_area_select, {
              "area-list": _ctx.areaList,
              "country-list": _ctx.countryList,
              onUpdateCountries: _ctx.onUpdateCountries
            }, null, 8, ["area-list", "country-list", "onUpdateCountries"])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "onInvalidSubmit"]),
      _createVNode(_component_Form, {
        onSubmit: _ctx.onShowEstimation,
        onInvalidSubmit: _ctx.onInvalidSubmit
      }, {
        default: _withCtx(() => [
          (_ctx.formStatus.isSearchedWiFi)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_wi_fi_product_select, {
                  "recommended-products": _ctx.wifiProducts,
                  "wifi-unit": _ctx.formData.order_pro_qty,
                  "onUpdate:wifi-unit": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.order_pro_qty) = $event)),
                  onUpdatedWiFi: _ctx.onWiFiUpdated
                }, null, 8, ["recommended-products", "wifi-unit", "onUpdatedWiFi"]),
                _createVNode(_component_receiving_method, {
                  modelValue: _ctx.formData.order_get_type,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.order_get_type) = $event)),
                  "prefecture-list": _ctx.prefectureList,
                  "shipment-pref": _ctx.formData.order_send_pref_id,
                  "onUpdate:shipment-pref": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.order_send_pref_id) = $event))
                }, null, 8, ["modelValue", "prefecture-list", "shipment-pref"]),
                _createVNode(_component_returning_method),
                _createVNode(_component_optional_insurance, {
                  modelValue: _ctx.formData.order_pro_insurance,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.order_pro_insurance) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_optional_products, {
                  "product-list": _ctx.optionalProducts,
                  onOptionUnitUpdated: _ctx.onOptionUnitUpdated
                }, null, 8, ["product-list", "onOptionUnitUpdated"]),
                _createVNode(_component_coupon_codes, {
                  "campaign-code": _ctx.formData.order_camp_code,
                  "onUpdate:campaign-code": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.order_camp_code) = $event)),
                  "agency-code": _ctx.formData.order_shop_code,
                  "onUpdate:agency-code": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.order_shop_code) = $event))
                }, null, 8, ["campaign-code", "agency-code"]),
                _createVNode(_component_payment_method, {
                  modelValue: _ctx.formData.order_pay_method,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.order_pay_method) = $event)),
                  "get-method": _ctx.formData.order_get_type,
                  "departure-date": _ctx.formData.order_from_date,
                  "arrival-date": _ctx.formData.order_to_date
                }, null, 8, ["modelValue", "get-method", "departure-date", "arrival-date"]),
                _createElementVNode("div", _hoisted_5, [
                  _withDirectives(_createElementVNode("p", { class: "invalid-message" }, _toDisplayString(_ctx.formStatus.estimationErrorMessage), 513), [
                    [_vShow, _ctx.formStatus.estimationErrorMessage]
                  ]),
                  _hoisted_6
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onSubmit", "onInvalidSubmit"]),
      (_ctx.globalState.couponCodes.agencyCode == 'kakaku')
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_11))
        : _createCommentVNode("", true),
      (_ctx.globalState.couponCodes.agencyCode == 'mobistar')
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_16))
        : _createCommentVNode("", true),
      (_ctx.formStatus.isEstimated)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createVNode(_component_estimation_result, {
              "estimation-data": _ctx.formStatus.estimationData,
              "arrival-date": _ctx.formData.order_to_date,
              "departure-date": _ctx.formData.order_from_date
            }, null, 8, ["estimation-data", "arrival-date", "departure-date"]),
            (!_ctx.globalState.$state.loginStatus.isLoggedIn)
              ? (_openBlock(), _createElementBlock("dl", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("dd", null, [
                      _hoisted_21,
                      _createElementVNode("button", {
                        class: _normalizeClass(["forward-button", { disabled: !_ctx.isInStock }]),
                        disabled: !_ctx.isInStock,
                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onForwardToCustomerProfile && _ctx.onForwardToCustomerProfile(...args)))
                      }, " お申込みへ進む ", 10, _hoisted_22)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("dd", null, [
                      _createVNode(_component_Form, { onSubmit: _ctx.onForwardWithLogin }, {
                        default: _withCtx(() => [
                          _hoisted_25,
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _createVNode(_component_input_field, {
                                label: "メールアドレス",
                                "input-name": "login_mail_address"
                              }, {
                                default: _withCtx(({ inputName }) => [
                                  _createVNode(_component_common_input, {
                                    modelValue: _ctx.userInfo.mail_address,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.userInfo.mail_address) = $event)),
                                    name: inputName,
                                    rules: _ctx.mailAddressValidRules
                                  }, null, 8, ["modelValue", "name", "rules"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_28, [
                              _createVNode(_component_input_field, {
                                label: "パスワード",
                                "input-name": "login_password"
                              }, {
                                default: _withCtx(({ inputName }) => [
                                  _createVNode(_component_common_input, {
                                    modelValue: _ctx.userInfo.passWord,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.userInfo.passWord) = $event)),
                                    name: inputName,
                                    "value-hide": true
                                  }, null, 8, ["modelValue", "name"])
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _withDirectives(_createElementVNode("p", { class: "invalid-message" }, _toDisplayString(_ctx.formStatus.loginErrorMessage), 513), [
                            [_vShow, _ctx.formStatus.loginErrorMessage]
                          ]),
                          _createElementVNode("button", {
                            class: _normalizeClass(["forward-button", { disabled: !_ctx.isInStock }]),
                            disabled: !_ctx.isInStock
                          }, " ログインして申し込む ", 10, _hoisted_29),
                          _createElementVNode("div", _hoisted_30, [
                            _createVNode(_component_router_link, {
                              to: "/reset-password",
                              class: "text-link"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" パスワードを忘れた方はこちら ")
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["onSubmit"])
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["forward-button", { disabled: !_ctx.isInStock }]),
                    disabled: !_ctx.isInStock,
                    onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.onForwardToCustomerProfile && _ctx.onForwardToCustomerProfile(...args)))
                  }, [
                    _createTextVNode(" お客様情報の入力へ "),
                    _hoisted_33
                  ], 10, _hoisted_32)
                ]))
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}